
        import './src/styles/main.css';
        import { auth } from './src/js/auth.js';

        // Check if already logged in
        if (auth.isAuthenticated()) {
            window.location.href = '/client/dashboard.html';
        }

        // Theme toggle functionality
        const themeToggle = document.getElementById('themeToggle');
        const htmlElement = document.documentElement;

        const getInitialTheme = () => {
            const savedTheme = localStorage.getItem('theme');
            if (savedTheme) return savedTheme;
            return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        };

        const setTheme = (theme) => {
            htmlElement.setAttribute('data-theme', theme);
            localStorage.setItem('theme', theme);
        };

        setTheme(getInitialTheme());

        if (themeToggle) {
            themeToggle.addEventListener('click', () => {
                const currentTheme = htmlElement.getAttribute('data-theme');
                const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
                setTheme(newTheme);
            });
        }

        // Login form handling
        const loginForm = document.getElementById('loginForm');
        const errorMessage = document.getElementById('errorMessage');
        const loginButton = document.getElementById('loginButton');

        loginForm.addEventListener('submit', async (e) => {
            e.preventDefault();

            const username = document.getElementById('username').value.trim();
            const password = document.getElementById('password').value;

            // Clear previous error
            errorMessage.style.display = 'none';
            errorMessage.textContent = '';

            // Disable button and show loading state
            loginButton.disabled = true;
            loginButton.innerHTML = '<span>Signing in...</span>';

            // Simulate slight delay for better UX
            setTimeout(() => {
                const result = auth.login(username, password);

                if (result.success) {
                    // Redirect to dashboard
                    window.location.href = '/client/dashboard.html';
                } else {
                    // Show error
                    errorMessage.textContent = result.message;
                    errorMessage.style.display = 'block';

                    // Re-enable button
                    loginButton.disabled = false;
                    loginButton.innerHTML = `
                        <span>Sign In</span>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M4 10h12m0 0l-6-6m6 6l-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    `;

                    // Clear password field
                    document.getElementById('password').value = '';
                }
            }, 500);
        });
    